





import React, { useEffect, useState } from "react";
import Preloader from "../Preloder/Preloader";
import axios from "axios";
import "./Examresult.css";

const Examresult = () => {
  const [examDetails, setExamDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [results, setResults] = useState([]);
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedExam, setSelectedExam] = useState(null);
  const [studentstd, setStudentstd] = useState("");
  const [studentid, setStudentid] = useState("");

  const user = localStorage.getItem("UserId");

  useEffect(() => {
    getStudentStandard();
    fetchExamList();
  }, []);

  const fetchExamList = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API}/questions/examdata`
      );
      setExamDetails(response.data);
    } catch (error) {
      console.error("Error fetching exam data:", error);
    } finally {
      setLoading(false);
    }
  };

  const getStudentStandard = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API}/adddetails/getStudentstd`,
        { params: { userId: user } }
      );
    
      setStudentstd(response.data.student_std);
      setStudentid(response.data.student_id);
    } catch (err) {
      console.error("Error fetching student standard:", err);
      setError("❌ Student not found. Please apply for the exam.");
    }
  };

  const isXIOrAbove = (std) => {
    const s = std?.toUpperCase().trim();
    return (
      s.includes("XI") || s.includes("XII") || s.includes("UG") || s.includes("PG")
    );
  };

  const handleClick = async (exam) => {
    try {
      setShowModal(true);
      setSelectedExam(exam);
      setLoading(true);
      setResults([]);
      setError("");

      // Always fetch online results
      const onlinePromise = axios.get(
        `${process.env.REACT_APP_API}/questions/exam-results/${exam.id}`
      );

      let resultsData = [];
      if (exam.id === 1) {
        // Fetch offline + online in parallel
        const [offlineRes, onlineRes] = await Promise.all([
          axios.get(`${process.env.REACT_APP_API}/questions/offline-exam-results`),
          onlinePromise,
        ]);
        resultsData = [...offlineRes.data, ...onlineRes.data];
      } else {
        const onlineRes = await onlinePromise;
        resultsData = onlineRes.data;
      }

      // Filter results
      const filtered = resultsData.filter((r) =>
        isXIOrAbove(studentstd)
          ? isXIOrAbove(r.standard)
          : !isXIOrAbove(r.standard)
      );

      // Sort results
      const sorted = filtered.sort((a, b) => b.total_correct - a.total_correct);

      setResults(sorted);
    } catch (err) {
      console.error("Error fetching results:", err);
      setError("❌ Error fetching exam results.");
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setResults([]);
    setSelectedExam(null);
    setError("");
  };

  return (
    <>
      <Preloader />
      <div className="exam-container">
        <h2 className="exam-header">📋 Exam Results</h2>

        {loading && examDetails.length === 0 ? (
          <Preloader />
        ) : examDetails.length === 0 ? (
          <p className="no-results">No results available.</p>
        ) : (
          <div className="exam-list">
            {examDetails.map((exam) => (
              <div
                key={exam.id}
                className="exam-card"
                onClick={() => handleClick(exam)}
              >
                <h3>{exam.title}</h3>
                <p>
                  <strong>Result Date:</strong> {exam.result_date}
                </p>
              </div>
            ))}
          </div>
        )}

        {showModal && (
          <div className="modal-overlay">
            <div className="modal-content">
              <h3>Results for: {selectedExam?.title}</h3>
              <button
                className="close-btn"
                onClick={closeModal}
                style={{ backgroundColor: "red" }}
              >
                ✖
              </button>

              {loading ? (
                <div className="modal-loader">
                  <Preloader /> {/* Spinner inside modal */}
                  <p>Loading results...</p>
                </div>
              ) : error ? (
                <p className="error-text">{error}</p>
              ) : results.length === 0 ? (
                <p>No results found.</p>
              ) : (
                <table className="results-table">
                  <thead>
                    <tr>
                      <th style={{ backgroundColor: "blue" }}>Rank</th>
                      <th style={{ backgroundColor: "blue" }}>Name</th>
                      <th style={{ backgroundColor: "blue" }}>Father's Name</th>
                      <th style={{ backgroundColor: "blue" }}>Student ID</th>
                      <th style={{ backgroundColor: "blue" }}>Standard</th>
                      <th style={{ backgroundColor: "blue" }}>
                        Total Questions
                      </th>
                      <th style={{ backgroundColor: "blue" }}>
                        Total Correct
                      </th>
                      <th style={{ backgroundColor: "blue" }}>
                        Total Time Taken
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {results.map((res, index) => {
                      const isCurrentUser = res.student_id === studentid;
                      return (
                        <tr
                          key={index}
                          style={{
                            backgroundColor: isCurrentUser
                              ? "#ffeeba"
                              : "transparent",
                            fontWeight: isCurrentUser ? "bold" : "normal",
                          }}
                        >
                          <td>{index + 1}</td>
                          <td>{res.name}</td>
                          <td>{res.father_name}</td>
                          <td>
                            {res.student_id}
                            {isCurrentUser && (
                              <span style={{ color: "green" }}> (You)</span>
                            )}
                          </td>
                          <td>{res.standard}</td>
                          <td>{res.total_questions}</td>
                          <td>{res.total_correct}</td>
                          <td>{res.total_time_taken}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Examresult;
